<template>
  <v-dialog
    fullscreen
    eager
    v-model="dialog"
    hide-overlay
    content-class="form-dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="dialog=false">
          <v-icon large color="primary">close</v-icon>
        </v-btn>
      </v-col>
      <v-container v-if="dialog">
        <v-form ref="form">
          <h2 class="primary--text font-weight-bold pt-5 pl-2" v-if="edit">
            {{ $t('settings/settings:country.country') + ' \'' + this.country.name + '\' - ' + this.country.id }}
          </h2>
          <h2 class="primary--text font-weight-bold pt-5 pl-2" v-else>
            {{ $t('buttons:add-specific', {specific: $t('settings/settings:country.country') }) }}
          </h2>
          <v-row justify="space-around">
            <v-col cols="12" md="5">
              <v-text-field
                  outlined
                  v-model="country.id"
                  :disabled="edit"
                  :label="$t('common:id')"
                  :rules="[ruleRequired($t('utils:rules.required'))]"
              />

              <v-text-field
                  outlined
                  v-model="country.name"
                  :label="$t('settings/settings:country.country')"
              />

              <v-text-field
                  outlined
                  v-model="country.alpha2"
                  :label="$t('settings/settings:country.alpha2')"
                  :rules="[
                    ruleLengthBeetweenOrEmpty(2, 2, $t('utils:rules.length-between', {from: 2, to: 2}))
                  ]"
              />

              <v-text-field
                  outlined
                  v-model="country.alpha3"
                  :label="$t('settings/settings:country.alpha3')"
                  :rules="[
                    ruleLengthBeetweenOrEmpty(3, 3, $t('utils:rules.length-between', {from: 3, to: 3}))
                  ]"
              />

              <v-text-field
                  outlined
                  v-model="country.timezone"
                  :label="$t('settings/settings:country.timezone')"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-card
                  elevation="0"
                  flat
                  tile
                  class="pl-3 pt-3 pb-md-3"
              >
                <TwoButtonDialog
                    ref="saveButton"
                    :btn-text="$t('buttons:save')"
                    color="primary"
                    :hideOverlay="true"
                    :dialog-title="$t('dialog:save-btn-title', {name : $t('settings/settings:country.country') })"
                    :dialog-text="$t('dialog:save-btn-dialog', {name : $t('settings/settings:country.country') })"
                    :button1-text="$t('buttons:save')"
                    :button2-text="$t('buttons:cancel')"
                    @clickedButton1="updateForm()"
                    @clickedButton2="$refs.saveButton.showDialog = false"
                />
                <DirtyConfirmButtonDialog
                    ref="dirtyDialog"
                    :btn-text="$t('buttons:back')"
                    color="grey"
                    :hideOverlay="true"
                    :dialog-title="$t('dialog:save-btn-title')"
                    :dialog-text="$t('dialog:save-btn-dialog')"
                    :button1-text="$t('dialog:dirty-save-btn-1-text')"
                    :button2-text="$t('dialog:dirty-save-btn-2-text')"
                    @clickedButton="dialog=false"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>

import DirtyConfirmButtonDialog from '@/modules/core/components/TwoButtonDialog/DirtyConfirmButtonDialog';
import {ruleRequired, ruleLengthBeetweenOrEmpty} from '@/modules/core/services/rules';
import TwoButtonDialog from '@/modules/core/components/TwoButtonDialog/TwoButtonDialog';
import CountryService from '@/modules/settings/services/country-service';
import Country from '@/modules/settings/data/country';
import Utils from '@/modules/core/services/utils';

export default {
  name: "CountryForm",
  components: {
    DirtyConfirmButtonDialog,
    TwoButtonDialog
  },
  data() {
    return {
      dialog: false,
      edit: false,
      country: new Country()
    }
  },
  methods: {
    ruleRequired,
    ruleLengthBeetweenOrEmpty,
    initialization(item) {
      this.country = new Country();
      this.edit = false;

      if (typeof item !== 'undefined' && typeof item.id !== 'undefined') {
        this.country = item;
        this.edit = true;
      }

      this.dialog = true;
    },
    updateForm() {
      if (!this.$refs.form.validate()) {
        this.$refs.saveButton.showDialog = false;
        window.scrollTo(0, 0);
        return;
      }

      this.dialog = false;
      CountryService.saveCountry(
        this.country,
        this.edit,
        () => {
          if (!this.edit) {
            Utils.showSuccessSnackbar(this.$t('snackbar:add-success', {name: this.$t('settings/settings:country.country')}));
          } else {
            Utils.showSuccessSnackbar(this.$t('snackbar:edit-success', {name: this.$t('settings/settings:country.country')}));
          }

          this.$emit('updateTable')
        },
        () => {
          if (!this.edit) {
            Utils.showFailureSnackbar(this.$t('snackbar:add-failure', {name: this.$t('settings/settings:country.country')}));
          } else {
            Utils.showFailureSnackbar(this.$t('snackbar:edit-failure', {name: this.$t('settings/settings:country.country')}));
          }
        }
      )
    }
  }
}
</script>
